import { render, staticRenderFns } from "./Relais.vue?vue&type=template&id=11a15a8e&scoped=true&"
import script from "./Relais.vue?vue&type=script&lang=js&"
export * from "./Relais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a15a8e",
  null
  
)

export default component.exports